import Img from 'src/components/shared/Img'
import Hyperlink from 'src/components/shared/HyperLink'
import PropTypes from 'prop-types'

const CARD_CLASS_NAME = 'relative h-[338px] w-[280px] rounded-[10px]'

const LeaderCardContent = ({ item }) => (
  <>
    <Img
      src={item.imageUrl}
      alt={item.imageAlt}
      width={280}
      height={338}
      layout="intrinsic"
    />
    {item?.title && (
      <div className="absolute bottom-0 left-0 flex h-[63px] w-full flex-col items-center gap-1 bg-white/80 p-1.5 text-gray-900">
        <span className="text-lg font-bold">{item.title}</span>
        <span className="text-sm font-normal">{item.subtitle}</span>
      </div>
    )}
  </>
)

LeaderCardContent.propTypes = {
  item: PropTypes.shape({
    imageUrl: PropTypes.string,
    imageAlt: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
}

const Leaders = ({ data }) => {
  return (
    <div className="flex flex-col items-center gap-8 lg:gap-16">
      <h3 className="text-center text-2.5xl font-bold lg:text-37">
        {data?.title}
      </h3>
      <div className="max-w-270 flex flex-row flex-wrap justify-center gap-x-8 gap-y-6">
        {data?.items?.map((item) =>
          item.href ? (
            <Hyperlink
              key={item.id}
              href={item.href}
              childrenClassNames={`${CARD_CLASS_NAME} text-gray-900 no-underline`}
              clickTrackText={item.title || item.imageAlt}
            >
              <LeaderCardContent item={item} />
            </Hyperlink>
          ) : (
            <div key={item.id} className={CARD_CLASS_NAME}>
              <LeaderCardContent item={item} />
            </div>
          )
        )}
      </div>
    </div>
  )
}

Leaders.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        imageAlt: PropTypes.string,
        imageUrl: PropTypes.string,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        href: PropTypes.string,
      })
    ),
  }),
}
Leaders.defaultProps = {
  data: {
    title: '',
    items: [],
  },
}

export default Leaders
